import {CustomerMessageRoomsState} from "../store/customer_message_rooms_state";
import {Reducer} from "redux";
import {CustomerMessageRoomsAction, CustomerMessageRoomsActionType,} from "../action/customer_message_rooms_action";

const initialState: CustomerMessageRoomsState = {
    messageRooms: [],
    companyWithProjectIDs: [],
    projects: [],
    latestMessages: [],
    initialMessageRoom: null,
    contracts: [],
    isLoading: false,
};

const customerMessageRoomsReducer: Reducer<CustomerMessageRoomsState> = (state = initialState, action: CustomerMessageRoomsAction): CustomerMessageRoomsState => {
    switch (action.type) {

        case CustomerMessageRoomsActionType.REQUEST_START_POLLING_MESSAGE_ROOMS: {
            return Object.assign({}, state, {
                isLoading: true,
            });
        }
        case CustomerMessageRoomsActionType.CALLBACK_START_POLLING_MESSAGE_ROOMS: {
            // const _action = action as ICallbackGetAllMessageRoomsAction;
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    messageRooms: action.item ? action.item.messageRooms : [],
                    companyWithProjectIDs: action.item ? action.item.companyWithProjectIDs : [],
                    projects: action.item ? action.item.projects : [],
                    latestMessages: action.item ? action.item.latestMessages : [],
                    initialMessageRoom: action.item ? action.item.initialMessageRoom : null,
                    contracts: action.item ? action.item.contracts : [],
                    isLoading: false,
                });
            } else {
                return Object.assign({}, state, {
                    isLoading: false,
                });
            }
        }
        case CustomerMessageRoomsActionType.REQUEST_STOP_POLLING_MESSAGE_ROOMS: {
            return Object.assign({}, state, {
                ...initialState
            })
        }

        default:
            return state;
    }
};

export default customerMessageRoomsReducer;



// WEBPACK FOOTER //
// ./src/presentation/reducer/customer_message_rooms_reducer.ts